import React from "react";
import ICompany from "../models/ICompany";
import { TextField } from "@material-ui/core";
import Autocomplete, { RenderInputParams } from "@material-ui/lab/Autocomplete";
import { selectCompany, selectAvailableCompanies } from "../store/context/selectors";
import { setCompany } from "../store/context/actions";
import { connect } from "react-redux";
import { IApplicationState } from "../store";
import { stringSort } from "../functions/sorts";

export interface ICompanySelectProps {
  company?: ICompany;
  companies: Array<ICompany>;
  setCompany: typeof setCompany;
}

const CompanySelect = (props: ICompanySelectProps) => {
  const { company, companies, setCompany } = props;

  const handleCompanyChange = (newCompany: ICompany | null) => {
    if (newCompany != null) {
      setCompany(newCompany);
    }
  };

  return (
    <Autocomplete
      id="company-select"
      options={companies.sort(stringSort(c => c.Name))}
      getOptionLabel={(option: ICompany) => option.Name}
      style={{ width: 500 }}
      renderInput={(params: RenderInputParams) => <TextField {...params} label={company ? company.Name : "Select company"} variant="outlined" fullWidth />}
      onChange={(event: any, value: ICompany | null) => handleCompanyChange(value)}
      value={company}
    />
  );
};

export default connect(
  (state: IApplicationState) => ({
    company: selectCompany(state),
    companies: selectAvailableCompanies(state),
  }),
  dispatch => ({
    setCompany: (company: ICompany | undefined) => dispatch(setCompany(company)),
  }),
)(CompanySelect);
